import React from 'react';

const Navbar = () => {
  return (
    <nav className="bg-white shadow-md sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 py-3 flex justify-between items-center">
        
        <div className="text-xl font-bold text-indigo-600">
          Priyanka.dev
        </div>

        <ul className="hidden md:flex space-x-6 text-gray-700 font-medium">
          <li>
            <a href="#home" className="hover:text-indigo-600">Home</a>
          </li>
          <li>
            <a href="#about" className="hover:text-indigo-600">About</a>
          </li>
          <li>
            <a href="#experience" className="hover:text-indigo-600">Experience</a>
          </li>
          <li>
            <a href="#projects" className="hover:text-indigo-600">Projects</a>
          </li>
          <li>
            <a href="#contact" className="hover:text-indigo-600">Contact</a>
          </li>
        </ul>

        {/* Mobile menu icon */}
        <div className="md:hidden text-2xl text-indigo-600 cursor-pointer">
          ☰
        </div>

      </div>
    </nav>
  );
};

export default Navbar;